import React from "react";
import { NavLink } from "react-router-dom";
import { useRoleVerify } from "Common/RoleVerify";
import { GetPageUrl, GetLastTwoUrl } from "utils/CommonUtils";

const AddItemBtn = ({ url, title, className = '', twoUrl = false }) => {
    const page_url = GetPageUrl()
    const getLastTwoUrl = GetLastTwoUrl()
    return (
        useRoleVerify('', ["can_create"]) &&
        <NavLink to={`/admin/${twoUrl ? getLastTwoUrl : page_url}/${url}`} aria-label={title} className={`btn btn-primary ${className && className}`}>{title}</NavLink>
    );
};

export default AddItemBtn;